import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Backdrop,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import DadosGerais from './DadosGerais';
import Itens from './Itens';
import Frete from './Frete';
import Parcelas from './Parcelas';
import Rodape from './Rodape';
import db from '../../../services/db'; // Banco de dados IndexedDB
import { syncDataFromDB } from '../../../services/sync/completeDataSync';
import { useAuth } from '../../../contexts/AuthContext';
import { useNotification } from '../../../contexts/NotificationContext';
import { format } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
function PedidosEdit({ mode }) {
  const { showNotification } = useNotification();
  const [isSaving, setIsSaving] = useState(false);
  const { logout, user, setUser } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams(); // Identifica o ID do pedido na URL
  const isViewMode = mode === 'view'; // Define se está no modo consulta
  const isEditMode = mode === 'edit'; // Define se está no modo edição
  const isDuplicar = mode === ''; // Define se está no modo edição
  const steps = ['Dados Gerais', 'Itens', 'Parcelas'];
  const [activeStep, setActiveStep] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [isParcelasEnabled, setParcelasEnabled] = useState(false);
  const [pedidoData, setPedidoData] = useState({
    idPedido: null,
    sincronismo: false,
    dadosGerais: {
      cliente: null,
      naturezaOperacao: null,
      formaPagamento: null,
      condicaoPagamento: null,
      ramoAtividade: null,
    },
    itens: [],
    frete: {
      valorFrete: 0,
      transportadora: null,
    },
    parcelas: [],
  });
  const calculateVencimento = (dataPedido, dias) => {
    const baseDate = new Date(dataPedido || Date.now());
    baseDate.setDate(baseDate.getDate() + dias);
    return baseDate.toISOString().split('T')[0]; // Formato YYYY-MM-DD
  };

  useEffect(() => {
    const fetchPedido = async () => {
      try {
        if (!id) return;

        const storedUser = await db.currentUser.get('currentUser');
        const vendedor = await db.vendedorModel.get(storedUser.vendedorModelId);
        // Busca o pedido pelo ID
        const pedido = await db.pedidos.get(Number(id));
        if (!pedido) {
          alert('Pedido não encontrado!');
          navigate('/pedidos');
          return;
        }

        console.log('Pedido encontrado:', pedido);

        // Resolver cliente e outros dados relacionados usando os IDs corretos
        var cliente = pedido.uuidCliente
          ? await db.clientes
            .where('uuidMobile')
            .equals(pedido.uuidCliente)
            .first()
          : null;

          if(cliente == null){
             cliente = pedido.idCliente ? await db.clientes.get(Number(pedido.idCliente)) : null;
          }

        const condicaoPagamento = pedido.idCondicaoPagamento
          ? await db.condicaoPagamento
            .where('idCondicaoPagamento')
            .equals(pedido.idCondicaoPagamento)
            .first()
          : null;
        const naturezaOperacao = pedido.idNaturezaOperacao
          ? await db.tiposOperacao
            .where('idNaturezaOperacao')
            .equals(pedido.idNaturezaOperacao)
            .first()
          : null;
        const formaPagto = pedido.idFormaPagamento
          ? await db.formasPagamentos.get(Number(pedido.idFormaPagamento))
          : null;
        // Se estiver duplicando, gerar novas parcelas

        // Transformar os itens para o modelo usado na tela de Itens
        const itensFormatados = (pedido.itens || []).map((item) => ({
          idProduto: item.idProduto,
          descricao: item.nomeProduto,
          codigoProduto: item.codigoProduto || null, // Garante que o código do produto esteja presente
          quantidade: item.quantidade || 0, // Garante que a quantidade seja pelo menos 0
          preco: item.valorUnitario || 0, // Define o preço unitário
          total: item.valorTotal || item.quantidade * (item.valorUnitario || 0), // Calcula o total caso não esteja definido
        }));

        console.log('Itens formatados:', itensFormatados);

        let novasParcelas = [];
        if (isDuplicar && condicaoPagamento) {
          const dias = condicaoPagamento.dias
            ? condicaoPagamento.dias.split(',').map((dia) => parseInt(dia.trim(), 10))
            : [];
          const enableParcelas = dias.length > 0;
          if (enableParcelas) {
            const valorTotal = itensFormatados.reduce((acc, item) => acc + item.total, 0);
            const parcelaValor = (valorTotal / dias.length).toFixed(2);
            novasParcelas = dias.map((dia, index) => ({
              numero: index + 1,
              dataVencimento: calculateVencimento(pedido.dataPedido, dia),
              valor: parcelaValor,
            }));
          }
        }


        console.log(isDuplicar)
        console.log(pedido.idPedido)
        console.log(pedido.idLocal)
        // Configuração do estado com dados resolvidos
        setPedidoData({
          idPedido: (isDuplicar ? 0 : pedido.idPedido),
          idLocal: (isDuplicar ? 0 : pedido.idLocal),

          sincronismo: pedido.sincronismo || false,
          dadosGerais: {
            numeroPedido: pedido.numeroPedido,
            cliente: cliente || null,
            naturezaOperacao: naturezaOperacao || null,
            formaPagamento: formaPagto || null,
            condicaoPagamento: condicaoPagamento || null,
            ramoAtividade: cliente?.ramoAtividade || null,
            vendedor: vendedor.nome || '',
            obsPedido: pedido.obsPedido
          },
          itens: itensFormatados,
          frete: {
            valorFrete: pedido.valorFrete || 0,
            transportadora: pedido.transportadora || null, // Ajuste conforme necessário
          },
          uuidMobile: isDuplicar ? '' : pedido.uuidMobile,
          parcelas: isDuplicar ? novasParcelas : pedido.parcelas || [],
          sincronismo: (isDuplicar ? 'false' : pedidoData.sincronismo),

        });
        handleConditionSelect(condicaoPagamento)
      } catch (error) {
        console.error('Erro ao buscar o pedido:', error);
        alert('Erro ao carregar o pedido.');
        navigate('/pedidos');
      }
    };

    if (isEditMode || isViewMode) {
      fetchPedido();
    }
  }, [id, isEditMode, isViewMode, navigate]);






  useEffect(() => {
    console.log(pedidoData)
  }, [pedidoData]);


  const handleNext = () => {
    if (activeStep === 0 && !validateDadosGerais()) {
      alert('Preencha todos os campos obrigatórios.');
      return;
    }
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);
  const handleBackToList = () => navigate('/pedidos');

  const updateStepData = (stepKey, data) => {
    setPedidoData((prevData) => ({
      ...prevData,
      [stepKey]: data,
    }));
  };

  // 🔄 SUBSTITUA a função antiga por esta nova versão
  const validateDadosGerais = () => {
    console.log('Arq')
    const { cliente, naturezaOperacao, formaPagamento, condicaoPagamento } =
      pedidoData.dadosGerais;

    // Campos sempre obrigatórios
    if (!cliente || !naturezaOperacao || !formaPagamento) return false;

    // Lê o código CFOP da natureza de operação
    const cfop = Number(
      naturezaOperacao.numero

    );

    // Se o CFOP for 6949 ou 5949, NÃO exige condicaoPagamento
    if (cfop === 6949 || cfop === 5949) return true;

    // Nos demais casos, condicaoPagamento continua obrigatória
    return !!condicaoPagamento;
  };


  const handleConditionChange = ({ enableParcelas, parcelas }) => {
    setParcelasEnabled(enableParcelas);
    updateStepData('parcelas', enableParcelas ? parcelas : []);
  };



  const handleSave = async () => {
    if (isSaving) return; // Impede execução duplicada
    setIsSaving(true);
    try {

      const storedUser = await db.currentUser.get('currentUser');
      const vendedor = await db.vendedorModel.get(storedUser.vendedorModelId);

      const idPedido = pedidoData.idPedido || 0; // Gera um ID único para o pedido
      if(idPedido!=0){
        console.log(pedidoData)
      }
      const shortUuid = uuidv4().replaceAll('-', '');

      // Transformar os itens para o formato esperado no fetchPedido
      const itensFormatados = pedidoData.itens.map((item) => ({
        idProduto: item.idProduto,
        nomeProduto: item.descricao, // Transforma 'descricao' em 'nomeProduto'
        codigoProduto: item.codigoProduto || null, // Adiciona 'codigoProduto' se existir
        quantidade: item.quantidade || 0, // Quantidade deve ser no mínimo 0
        valorUnitario: item.preco || 0, // Transforma 'preco' em 'valorUnitario'
        valorTotal: item.total || 0, // Transforma 'total'
      }));

      // Preenche o pedido no formato esperado
      const pedidoParaSalvar = {
        idlocal: (isDuplicar ? 0 : pedidoData.idLocal),
        idPedido,
        numeroPedido: pedidoData.dadosGerais.numero || '',
        idCliente: pedidoData.dadosGerais.cliente?.idCliente || null,
        nomeCliente: pedidoData.dadosGerais.cliente
          ? (pedidoData.dadosGerais.cliente.codigo == null ? 'Offline' : pedidoData.dadosGerais.cliente.codigo) + `-${pedidoData.dadosGerais.cliente.nome}`
          : null,
        idFormaPagamento: pedidoData.dadosGerais.formaPagamento?.idFormaPagamento || null,
        idCondicaoPagamento: pedidoData.dadosGerais.condicaoPagamento?.idCondicaoPagamento || null,
        idNaturezaOperacao: pedidoData.dadosGerais.naturezaOperacao?.idNaturezaOperacao || null,
        status: 'I',
        metodoPagamento: pedidoData.dadosGerais.formaPagamento?.descricao || null,
        dataPedido: new Date().toISOString(),
        valorTotal: valorTotal,
        valorFrete: pedidoData.frete.valorFrete || 0,
        itens: itensFormatados,
        parcelas: pedidoData.parcelas,
        sincronismo: 'false', // Força o formato string
        isDeleted: false,
        vendedor: vendedor,
        descricaoSerie: 'PDM',
        uuidMobile: shortUuid,
        obsPedido: pedidoData.dadosGerais.obsPedido,
        uuidCliente: pedidoData.dadosGerais.cliente?.uuidMobile
      };

      console.log('Pedido formatado para salvar:', pedidoParaSalvar);
      console.log('tesr', pedidoParaSalvar)


      // Salva no IndexedDB
      //await db.pedidos.put(pedidoParaSalvar);
      console.log('aq')
      const existingCliente = pedidoParaSalvar.idlocal ? await db.pedidos.get(Number(pedidoParaSalvar.idlocal)) : null;
      if (existingCliente) {
        // Atualiza o cliente no IndexedDB
        await db.pedidos.update(Number(id), { ...pedidoParaSalvar, });

      } else {
        // Adiciona o cliente no IndexedDB

        await db.pedidos.add({ ...pedidoParaSalvar, });

      }


      //console.log('Chamando syncDataFromDB...');
      //await syncDataFromDB(storedUser);


      showNotification('Pedido salvo com sucesso!');
      navigate('/pedidos');
    } catch (error) {
      console.error('Erro ao salvar o pedido:', error);
      showNotification('Erro ao salvar o pedido. Tente novamente.');
    } finally {
      setIsSaving(false); // Desativa o estado de carregamento
    }
  };


  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <DadosGerais
            data={pedidoData.dadosGerais || {}} // Garante que dadosGerais seja um objeto
            onDataChange={(data) => updateStepData('dadosGerais', data)}
            onConditionChange={handleConditionChange}
            disableFields={isViewMode}
          />
        );
      case 1:
        return (
          <Itens
            data={pedidoData.itens || []} // Garante que itens seja uma lista
            onDataChange={(data) => updateStepData('itens', data)}
            ramoAtividade={pedidoData.dadosGerais?.ramoAtividade}
            disableFields={isViewMode}
          />
        );
      case 2:
        return (
          <Parcelas
            data={pedidoData.parcelas || []} // Garante que parcelas seja uma lista
            onDataChange={(data) => updateStepData('parcelas', data)}
            disableFields={isViewMode}
            itens={pedidoData.itens || []}
          />
        );
      default:
        return null;
    }
  };

  const handleConditionSelect = (selectedOption) => {
    // Obtém os dias da condição de pagamento
    const dias = selectedOption.dias
      ? selectedOption.dias.split(',').map((dia) => parseInt(dia.trim(), 10))
      : [];
    const enableParcelas = dias.length > 0;

    let parcelas = [];
    if (enableParcelas) {
      const valorTotal = parseFloat(pedidoData.valorTotal || 0);
      const parcelaValorBase = valorTotal / dias.length;

      // Arredonda o valor base para duas casas decimais
      const parcelaValor = parseFloat(parcelaValorBase.toFixed(2));

      // Calcula a diferença devido ao arredondamento
      const totalParcelas = parcelaValor * dias.length;
      const diferenca = parseFloat((valorTotal - totalParcelas).toFixed(2));

      // Gera as parcelas com os dias fornecidos
      const dataPedido = new Date(
        pedidoData.dadosGerais.dataPedido || new Date().toISOString().split('T')[0]
      );
      parcelas = dias.map((dia, index) => {
        let vencimento = new Date(dataPedido);
        vencimento.setDate(dataPedido.getDate() + dia + 1);
        console.log(dataPedido.getDate());
        const valor =
          index === dias.length - 1
            ? parseFloat((parcelaValor + diferenca).toFixed(2)) // Ajusta a última parcela
            : parcelaValor;

        return {
          numero: index + 1,
          dataVencimento: vencimento.toISOString().split('T')[0],
          valor: valor.toFixed(2),
        };
      });
    }

    handleConditionChange({ enableParcelas, parcelas });

  };

  useEffect(() => {
    const totalPedido = pedidoData.itens.reduce((acc, item) => acc + (item.total || 0), 0);
    const totalItens = pedidoData.itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);

    setValorTotal(totalItens);
  }, [pedidoData.itens]);



  return (
    <Box sx={{ padding: 2 }}>
      <Backdrop open={isSaving} sx={{ color: '#fff', zIndex: 1300 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stepper activeStep={activeStep} sx={{ marginBottom: 3 }}>
        {steps.map((label, index) => (
          <Step key={index} disabled={label === 'Parcelas' && !isParcelasEnabled}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {renderStepContent()}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 3,
        }}
      >
        <Button
          variant="contained"
          onClick={activeStep === 0 ? handleBackToList : handleBack}
        >
          Voltar
        </Button>





        {activeStep === 2 && isViewMode ? (
          <Button
            variant="contained"

            onClick={handleBackToList}
          >
            Voltar para Listagem
          </Button>
        ) : (
          <Button
            variant="contained"
            disabled={isSaving}
            onClick={activeStep < steps.length - 1 ? handleNext : handleSave}
          >
            {activeStep < steps.length - 1 ? 'Avançar' : 'Salvar Pedido'}
          </Button>
        )}




      </Box>

      <Rodape itens={pedidoData.itens || []} />
    </Box>
  );
}

export default PedidosEdit;
